import React from 'react';
import { string, element, bool, func, oneOfType, shape, instanceOf } from 'prop-types';
import cn from 'classnames';

import SectionTitle from '~components/SectionTitle';

import styles from './styles.module.scss';

function Card({
  title,
  titleTag,
  titleId,
  children,
  renderHeader,
  titleClassName,
  titleBarActions,
  titleIcon,
  titleIconSvg,
  transparent,
  className,
  overrideClasses,
  containerId,
  cardRef,
  hideSeparator,
  onClick
}) {
  return (
    <div
      {...(containerId && { id: containerId })}
      className={cn(styles.container, className, {
        'column m-bottom-3': !overrideClasses,
        [styles.transparent]: transparent
      })}
      onClick={onClick}
      ref={cardRef}>
      {renderHeader}
      {title && (
        <SectionTitle
          title={title}
          actions={titleBarActions}
          tag={titleTag}
          icon={titleIcon}
          iconSvg={titleIconSvg}
          hideSeparator={hideSeparator}
          titleClassName={titleClassName}
          {...(titleId && { id: titleId })}
          className={`m-bottom-3 ${titleClassName}`}
        />
      )}
      {children}
    </div>
  );
}

Card.propTypes = {
  cardRef: oneOfType([func, shape({ current: instanceOf(Element) })]),
  className: string,
  containerId: string,
  hideSeparator: bool,
  overrideClasses: bool,
  renderHeader: element,
  title: string,
  titleBarActions: func,
  titleClassName: string,
  titleIcon: string,
  titleIconSvg: element,
  titleId: string,
  titleTag: string,
  transparent: bool,
  onClick: func
};

Card.defaultProps = {
  className: ''
};

export default Card;
